import React, { useCallback, useEffect } from "react";
import usePagination from "hooks/usePagination";
import * as styles from "./styles.mod.scss";

const Pagination = ({
  onPageChange,
  afterPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
}) => {
  const ellipsis = "...";

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const changeUrl = (page) => {
    const url = new URL(window.location.href);
    if (page === 1) url.searchParams.delete("page");
    else url.searchParams.set("page", page);
    window.history.pushState({}, "", url);
  };

  const changePage = (pageNumber) => {
    onPageChange(pageNumber);
    changeUrl(pageNumber);
    afterPageChange && afterPageChange();
  };


  const onNext = useCallback(() => changePage(currentPage + 1), [currentPage, changePage]);

  const onPrevious = useCallback(() => changePage(currentPage - 1), [currentPage, changePage]);

  useEffect(() => {
    const handlePopState = () => {
      onPageChange(parseInt(new URL(window.location.href).searchParams.get("page")) || 1);
    };


    window.addEventListener("popstate", handlePopState());

    return () => {
      window.removeEventListener("popstate", handlePopState());
    };
  }, [onPageChange]);

  let lastPage;

  if (paginationRange !== undefined) {
    lastPage = paginationRange[paginationRange?.length - 1];
  }


  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  return (
    <div className={styles.paginationContainer}>
      <span className={`${styles.paginationItem} ${currentPage === 1 && styles.disablePaginationItem}`} onClick={onPrevious}>
        «
      </span>
      {paginationRange?.map((pageNumber) =>
        pageNumber === ellipsis ? (
          <span key={`p${pageNumber}`} className={styles.paginationItem}>
            &#8230;
          </span>
        ) : (
          <span
            key={pageNumber}
            className={`${styles.paginationItem} ${pageNumber === currentPage ? styles.activePage : ""}`}
            onClick={() => changePage(pageNumber)}
          >
            {pageNumber}
          </span>
        )
      )}
      <span className={`${styles.paginationItem} ${lastPage <= currentPage && styles.disablePaginationItem}`} onClick={onNext}>
        »
      </span>
    </div>
  );
};

export default Pagination;